import { createFileRoute } from "@tanstack/react-router";
import { LegalList, LegalPage, LegalSection } from "@/components/LegalPage";

export const Route = createFileRoute("/reembolso")({
  head: () => ({
    meta: [
      { title: "Política de Reembolso — Projeto 101" },
      {
        name: "description",
        content:
          "Garantia incondicional de 7 dias para o 101 Negócios Reais: como solicitar, prazos e procedimento de estorno.",
      },
      { property: "og:title", content: "Política de Reembolso — Projeto 101" },
      { property: "og:description", content: "Garantia de 7 dias, procedimento e prazos de estorno." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: ReembolsoPage,
});

function ReembolsoPage() {
  return (
    <LegalPage
      title="Política de Reembolso"
      updatedAt="22 de julho de 2026"
      intro="Queremos que sua experiência com o 101 Negócios Reais seja segura do início ao fim. Por isso oferecemos garantia incondicional de 7 dias, em conformidade com o artigo 49 do Código de Defesa do Consumidor."
    >
      <LegalSection n={1} title="Prazo da garantia">
        <p>
          Você tem <strong>7 dias corridos</strong>, contados a partir da data de confirmação do
          pagamento, para solicitar o cancelamento da compra e o reembolso integral.
        </p>
        <p>Não é necessário justificar o motivo. Basta enviar sua solicitação dentro do prazo.</p>
      </LegalSection>

      <LegalSection n={2} title="Como solicitar o reembolso">
        <p>Envie um e-mail para nosso suporte contendo:</p>
        <LegalList
          items={[
            "nome completo;",
            "e-mail utilizado na compra;",
            "CPF do comprador;",
            "data aproximada da compra.",
          ]}
        />
        <p>
          Solicitações:{" "}
          <a href="mailto:suporte@101negocios.com.br" className="underline text-[#1E7A5C]">
            suporte@101negocios.com.br
          </a>
        </p>
      </LegalSection>

      <LegalSection n={3} title="Prazos de processamento">
        <LegalList
          items={[
            "Análise da solicitação: até 2 dias úteis após o recebimento do e-mail.",
            "Estorno via PIX: em geral, em até 2 dias úteis após a aprovação.",
            "Estorno em cartão de crédito: pode aparecer em até 2 faturas subsequentes, conforme prazos da operadora.",
          ]}
        />
      </LegalSection>

      <LegalSection n={4} title="Após o reembolso">
        <LegalList
          items={[
            "O acesso à área de membros será encerrado.",
            "Os bônus digitais e ferramentas complementares deixarão de ficar disponíveis.",
            "O uso do material após o reembolso é vedado e sujeito às sanções previstas nos Termos de Uso.",
          ]}
        />
      </LegalSection>

      <LegalSection n={5} title="Após o prazo de 7 dias">
        <p>
          Encerrado o período de garantia, não haverá reembolso, salvo hipóteses previstas em lei.
        </p>
      </LegalSection>

      <LegalSection n={6} title="Contato">
        <p>
          Projeto 101 — Suporte:{" "}
          <a href="mailto:suporte@101negocios.com.br" className="underline text-[#1E7A5C]">
            suporte@101negocios.com.br
          </a>
        </p>
      </LegalSection>
    </LegalPage>
  );
}
